import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import queryKeys from '../query-keys'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'
import { ProjectModelType } from '@/types/project-models'

const service = buildService<ProjectModelType>({
  pathCategory: 'project_model_types',
})

export function useGetProjectModelType({
  id,
  ...options
}: UseGetDetailOptions<ProjectModelType>) {
  const query = useGetDetail<ProjectModelType>({
    id,
    queryKey: queryKeys.projectModelTypes.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    projectModelType: query.data,
    ...query,
  }
}

export function useGetProjectModelTypes({
  filters,
  ...options
}: UseGetListOptions<ProjectModelType> = {}) {
  const query = useGetList<ProjectModelType>({
    filters,
    queryKey: queryKeys.projectModelTypes.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    projectModelTypes: query.allData,
    ...query,
  }
}
